import { nextPage, selectBookings, selectBookingsLoading } from "@/entities/booking"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Loader } from "@/shared/ui/loader"
import { NoTableData } from "@/shared/ui/no-table-data"
import { useEffect, useRef } from "react"
import { Booking } from "../booking"

export const BookingsList = () => {
    const observerRef = useRef<HTMLDivElement>(null)
    const dispatch = useAppDispatch()
    const bookings = useAppSelector(selectBookings)
    const bookingsLoading = useAppSelector(selectBookingsLoading)

    const observerOptions: IntersectionObserverInit = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0
    }

    useEffect(() => {
        const handleObserve = (entries: IntersectionObserverEntry[]) => {
            const [entry] = entries
            if (entry?.isIntersecting) {
                dispatch(nextPage())
            }
        }
        const observer = new IntersectionObserver(handleObserve, observerOptions)
        if (observerRef.current) observer.observe(observerRef.current)
        return () => {
            if (observerRef.current) observer.unobserve(observerRef.current)
        }
    }, [observerRef, observerOptions])

    return (
        <>
            {Boolean(bookings.length) &&
                <div className="flex flex-col gap-3">
                    {bookings.map((booking) => 
                        <Booking 
                            booking={booking.book} 
                            key={booking.book.booking_id} 
                        />
                    )}
                    {bookingsLoading &&
                        <div className="info_panel">
                            <Loader />
                        </div>
                    }
                    <div ref={observerRef} id="observer" />
                </div>
            }
            {(!Boolean(bookings.length) && bookingsLoading) &&
                <div className="info_panel">
                    <Loader />
                </div>
            }
            {(!Boolean(bookings.length) && !bookingsLoading) &&
                <NoTableData label="Нет активных забронированных авиабилетов" />
            }
        </>
    )
}
